import { serializer } from "@/api/shared/serializer";
import * as firebase from "firebase";
import moment from "moment";

export const getDraftEventsByTimeframe = async (facilityId: string, dates: string[]) => {

  const fromDate = moment(dates[0]).startOf('day').toDate();
  const toDate = dates[1] ? moment(dates[1]).endOf('day').toDate() : moment().endOf('day').toDate()

  const draftEvants = await firebase
    .firestore()
    .collection("calender")
    .where("facilityId", "==", facilityId)
    .where("start", ">=", fromDate)
    .where("start", "<=", toDate)
    .where("isPublished", "==", false).get();

  return serializer.querySnapshotToDocuments(draftEvants);
};